module.exports = __webpack_public_path__ + "static/img/3.f6bb719.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/3.png
// module id = DUhQ
// module chunks = 0